import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addBulkTrainer, addSingleTrainer, changeSingleTrainerStatus, deleteSingleTrainer, trainerList, updateSingleTrainer } from "../apis/apiHandler";

export const trainers = createAsyncThunk(
    "trainers/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await trainerList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addTrainer = createAsyncThunk(
    "trainers/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleTrainer(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const bulkTrainer = createAsyncThunk(
    "trainers/addBulk",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addBulkTrainer(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateTrainer = createAsyncThunk(
    "trainers/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleTrainer(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteTrainer = createAsyncThunk(
    "trainers/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleTrainer(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeTrainerStatus = createAsyncThunk(
    "trainers/changeStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeSingleTrainerStatus(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    trainerList: [],
    addTrainerData: {},
    updateTrainerData: {},
    deleteTrainerData: {},
    changeTrainerStatusData: {},
    error: null,
    success: false,
};

const trainerSlice = createSlice({
    name: "trainer",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(trainers.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(trainers.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.trainerList = payload;
                state.success = true;
            })
            .addCase(trainers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addTrainer.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addTrainer.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addTrainerData = payload;
                state.success = true;
            })
            .addCase(addTrainer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(bulkTrainer.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(bulkTrainer.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addTrainerData = payload;
                state.success = true;
            })
            .addCase(bulkTrainer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateTrainer.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateTrainer.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateTrainerData = payload;
                state.success = true;
            })
            .addCase(updateTrainer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteTrainer.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteTrainer.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteTrainerData = payload;
                state.success = true;
            })
            .addCase(deleteTrainer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeTrainerStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeTrainerStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeTrainerStatusData = payload;
                state.success = true;
            })
            .addCase(changeTrainerStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default trainerSlice.reducer;
